import { Link } from "@tanstack/react-router";
import { Syringe } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import { Route as NewInterventionRoute } from "@/routes/_app/new/diary/$diaryId/events/$eventId";
import { cn } from "@/lib/utils";
import type { ExtendedEventViewT } from "@/types/database/events";
import EducationItem from "../features/educations/EducationItem";
import InjectionItem from "../../injection/components/InjectionItem";
import ShockwaveItem from "../../shockwave/components/ShockwaveItem";
import SurgeryItem from "../features/surgeries/components/SurgeryItem";

interface Props {
	event: ExtendedEventViewT;
	editable?: boolean;
	trackerId?: string;
}
const EventSwitch = ({ event, editable = true, trackerId }: Props) => {
	const hasInjections = (event.injections_view?.length ?? 0) > 0;
	const hasSurgeries = (event.surgeries_view?.length ?? 0) > 0;
	const hasShockwaves = (event.shockwaves_view?.length ?? 0) > 0;
	const hasEducations = (event.educations?.length ?? 0) > 0;
	const hasInterventions = hasInjections || hasSurgeries || hasShockwaves ||
		hasEducations;

	return (
		<>
			{event.injections_view?.map((i) => (
				<InjectionItem
					event={event}
					trackerId={trackerId}
					key={i.injection_id}
					organisationId={event.organisation_id as string}
					injection={i}
					eventId={event.event_id}
					diaryId={event.diary_id}
					editable={editable}
				/>
			))}
			{event.surgeries_view?.map((s) => (
				<SurgeryItem
					event={event}
					trackerId={trackerId}
					key={s.surgery_id}
					organisationId={event.organisation_id as string}
					surgery={s}
					eventId={event.event_id}
					diaryId={event.diary_id}
					editable={editable}
				/>
			))}
			{event.shockwaves_view?.map((s) => (
				<ShockwaveItem
					event={event}
					trackerId={trackerId}
					key={s.shockwave_id}
					organisationId={event.organisation_id as string}
					shockwave={s}
					eventId={event.event_id}
					diaryId={event.diary_id}
					editable={editable}
				/>
			))}
			{event.educations?.map((e) => (
				<EducationItem
					event={event}
					trackerId={trackerId}
					key={e.education_id}
					organisationId={event.organisation_id as string}
					education={e}
					eventId={event.event_id}
					diaryId={event.diary_id}
					editable={editable}
				/>
			))}

			{!hasInterventions && (
				<Link
					to={NewInterventionRoute.to}
					params={{
						diaryId: event.diary_id,
						eventId: event.event_id,
					}}
					className={cn(
						buttonVariants({ size: "sm", variant: "link" }),
						"flex gap-2 mx-auto text-lg w-fit",
					)}
				>
					<Syringe size={24} strokeWidth={1.5} />
					<span>Add Intervention</span>
				</Link>
			)}
		</>
	);
};

export default EventSwitch;
